import extractSecretKey from '../data_management/extractSecretKey'
import insertOrganization from '../data_management/insertOrganization'
import updateOrganization from '../data_management/updateOrganization'
import deleteOrganization from '../data_management/deleteOrganization'

class OrganizationInteractor {
  constructor(initialDataInteractor, coachGateway) {
    this.initialDataInteractor = initialDataInteractor;
    this.coachGateway = coachGateway;
  }

  createNewOrganization(name, onSuccess) {
    this.coachGateway.createOrganization(extractSecretKey(this.initialDataInteractor), name, function (data) {
      insertOrganization(this.initialDataInteractor, data);
      onSuccess();
    }.bind(this))
  }

  updateOrganization(memberIdArray, organizationId, organizationName) {
    let data = {
      'id': organizationId,
      'memberIds': memberIdArray,
      'name': organizationName
    };

    return this.coachGateway.updateOrganization(extractSecretKey(this.initialDataInteractor), data).then(() => updateOrganization(this.initialDataInteractor, organizationId, organizationName, memberIdArray));
  }

  deleteOrganization(organizationId) {
    return this.coachGateway.deleteOrganization(extractSecretKey(this.initialDataInteractor), organizationId).then(() => deleteOrganization(this.initialDataInteractor, organizationId))
  }
}

export default OrganizationInteractor;